import React, { Component } from 'react';
import { Select, Input, Checkbox, Button, Form, Modal, Spin, message } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone, UserOutlined } from '@ant-design/icons';
import 'antd/dist/reset.css'; // antd v5. For antd v4 use 'antd/dist/antd.css'
import './DayimtrucksLoginPage.css';
import truckLogo from '../assets/images/dayim-logo.png';
import truckBgImage from '../assets/images/dayim-bg.png';
import withRouter from "../withRouter";
import { StoreContext } from '../store/RootStore';
import { observer } from 'mobx-react';
import Cookies from "universal-cookie";
import ForgetPassStore from '../store/ForgetPassStore.js';
const LANGUAGES = [
    { value: 'english', label: 'English' },
    { value: 'arabic', label: 'العربية' },
];

class DayimtrucksLoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedLang: "english",
            username: '',
            password: '',
            remember: true,
            loading: false,
            error: '',
            forgetpassmodal: false,
            forgetPassLoading: false
        };

        this.cookies = new Cookies();
        this.forgetPassStore = new ForgetPassStore(this);
        this.forgetFormRef = React.createRef(this);
    }

    handleRemember = (e) => {
        this.setState({ remember: e.target.checked });
    };

    resetpass = () => {
        this.setState({ forgetpassmodal: true });
    };
    onFinishForgetPass = async (values) => {
        await this.setState({ forgetPassLoading: true });
        const resp = await this.forgetPassStore.forgetPass(values);

        // if (res.data.success === "success") {
        //   // Modal.success({
        //   //   content:this.context.translate( res.data.message),
        //   // });
        //  await message.success(res.data.message);
        //  await this.setState({forgetpassmodal:false})
        // } else {
        //   Modal.error({
        //     // content:res.data.errors[0].erroruser,
        //     title: this.context.translate("_ERROR_"),

        //     content:this.context.translate( res.data.errors[0].erroruser),
        //     // bodyStyle: { padding: "20px" ,background:"yellow"},
        //   });
        // }

        if (resp.data.success === "S") {
            message.success(resp.data.message);
            await this.setState({ forgetPassLoading: false });
            await this.setState({ forgetpassmodal: false });
        } else if (resp.data.success === "F0") {
            // resp.data.errors.map((value) => {

            message.error(this.context.translate(resp.data.errors[0].erroruser));
            await this.setState({ forgetPassLoading: false });
            // });
        }
    };

    render() {
        return (
            <div className="login-page" style={{ backgroundImage: `url(${truckBgImage})` }}>

                <div
                    className="login-hero" />

                <div className="login-panel">
                    <img className="login-logo" src={truckLogo} alt="Dayim Trucks" />
                    <h1 className="login-welcome">WELCOME TO</h1>
                    <h2 className="login-brand">DAYIM TRUCKS</h2>

                    <Form className="login-card"
                        initialValues={{
                            remember: true,
                            selectedLang: this.cookies.get("language") || "english",
                        }}
                        onFinish={(values) => {
                            this.props.onSubmit(values);
                        }}

                        layout="vertical"
                    >
                        <div className="login-field">
                            <Form.Item
                                name="selectedLang"
                                label={this.context.translate(
                                    "_FLEET_LOGIN_LANGUAGE_"
                                )}>

                                <Select
                                    options={LANGUAGES}
                                    onChange={this.props.onLangChange}
                                    className="language-field"
                                />

                            </Form.Item>
                        </div>

                        <div className="login-field">
                            <Form.Item
                                name="userEmail"
                                label={this.context.translate(
                                    "_EMAIL_USER_NAME_"
                                )}
                                className="user-field"
                                rules={[
                                    {
                                        required: true,
                                        message: this.context.translate(
                                            "_FLEET_COMPANY_USERNAME_PROVIDE_"
                                        ),
                                    },
                                ]}
                            >
                                <Input
                                    // id="username"
                                    addonBefore={<UserOutlined />}
                                    placeholder={this.context.translate("_ENTER_YOUR_USER_NAME_")}
                                // value={username}
                                // onChange={this.handleChange('username')}
                                // autoComplete="username"
                                />
                            </Form.Item>

                        </div>

                        <div className="login-field">
                            <Form.Item
                                className="loginPassword"
                                label={this.context.translate(
                                    "_FLEET_COMPANY_USERDETAIL_PASSWORD_"
                                )}
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: this.context.translate(
                                            "_FLEET_COMPANY_PASSWORD_PROVIDE_"
                                        ),
                                    },
                                ]}

                            >
                                <Input.Password
                                    autoComplete="fail"
                                    type="password"
                                    placeholder={this.context.translate(
                                        "_FLEET_LOGIN_PASSWORDLBL_"
                                    )}
                                    size="large"
                                    iconRender={(visible) =>
                                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                    }
                                />
                            </Form.Item>

                        </div>
                        <Form.Item name="remember" valuePropName="checked">
                            <Checkbox>
                                {this.context.translate("_FLEET_LOGIN_REMEMBER_")}
                            </Checkbox>
                        </Form.Item>

                        <Button
                            className="login-submit"
                            type="primary"
                            htmlType="submit"
                            block
                            loading={this.props.loading}
                        >
                            {this.context.translate("_SIGN_IN_")}
                        </Button>

                        <button
                            type="button"
                            className="login-forgot"
                            onClick={() => this.setState({ forgetpassmodal: true })}
                        >
                            {this.context.translate("_FLEET_LOGIN_FRWDBTN_")}
                        </button>
                    </Form>

                    <div className="login-powered">Powered by AWTL</div>
                </div>

                {this.state.forgetpassmodal && (
                    <Modal
                        title={this.context.translate("_FLEET_LOGIN_FRWDBTN_")}
                        open={this.state.forgetpassmodal}
                        onCancel={() => this.setState({ forgetpassmodal: false })}
                        footer={null}
                        maskClosable={false}
                        centered
                        style={{ padding: "20px", maxWidth: "440px" }}
                    >
                        <div>
                            <Spin spinning={this.state.forgetPassLoading} fullscreen>
                                <Form
                                    name="basic"
                                    ref={this.forgetFormRef}
                                    onFinish={this.onFinishForgetPass}
                                >
                                    <Form.Item
                                        name="useremail"
                                        rules={[
                                            {
                                                required: true,
                                                type: "email",
                                                message: this.context.translate("_ENTER_EMAILID_"),
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="customInput"
                                            placeholder={this.context.translate(
                                                "_ENTER_EMAILID_"
                                            )}
                                        />
                                    </Form.Item>
                                    <br />
                                    <Form.Item>
                                        <div className="forgetPassBtns">
                                            <Button
                                                className="commonBtns blueBtn"
                                                htmlType="submit"
                                            >
                                                {this.context.translate(
                                                    "_FLEET_DASHBORD_VEHICLE_COMMAND_SENDBTN_"
                                                )}
                                            </Button>
                                            <Button
                                                className="commonBtns grayBtn"
                                                onClick={() => {
                                                    this.forgetFormRef.current?.resetFields();
                                                    this.setState({ forgetpassmodal: false });
                                                }}
                                            >
                                                {this.context.translate(
                                                    "_FLEET_DASHBORD_SHOWPOI_CANCELBTN_"
                                                )}
                                            </Button>
                                        </div>
                                    </Form.Item>
                                </Form>
                            </Spin>
                        </div>
                    </Modal>
                )}
            </div>
        );
    }
}
DayimtrucksLoginPage.contextType = StoreContext;
export default observer(withRouter(DayimtrucksLoginPage));
